/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  type: 'info',
  message: 'text',
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    showNotification(state, action) {
      state.open = true;
      state.type = action.payload.type;
      state.message = action.payload.message;
    },
    closeNotification(state) {
      state.open = false;
    },
  },
});

export const getNotificationData = (state) => state.notifications;

export const { showNotification, closeNotification } = notificationsSlice.actions;
export default notificationsSlice.reducer;
